import { useEffect } from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQ } from "@/content/copy";

export default function Faq() {
  // FAQPage structured data - generated from the same copy that renders on
  // the page, so the structured data can never drift from visible content.
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "faq-jsonld";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: FAQ.items.map((item) => ({
        "@type": "Question",
        name: item.q,
        acceptedAnswer: { "@type": "Answer", text: item.a },
      })),
    });
    document.head.appendChild(script);
    return () => document.getElementById("faq-jsonld")?.remove();
  }, []);

  return (
    <section id="faq" data-testid="faq-section" className="py-20 lg:py-32">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-sm font-bold uppercase tracking-widest text-terracotta">{FAQ.overline}</p>
        <h2 className="mt-3 text-3xl sm:text-4xl font-bold tracking-tight text-navy">{FAQ.title}</h2>
        <Accordion type="single" collapsible className="mt-10">
          {FAQ.items.map((item, i) => (
            <AccordionItem
              key={item.q}
              value={`faq-${i}`}
              data-testid={`faq-item-${i + 1}`}
              className="border-b border-border"
            >
              <AccordionTrigger
                data-testid={`faq-question-${i + 1}`}
                className="text-left text-base font-semibold text-navy hover:text-terracotta py-5"
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-base text-navy/70 leading-relaxed pb-5">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
